module.exports = __webpack_public_path__ + "static/img/testimony (39).331eb774.jpg";